import _ from "lodash";
import { FOLDER } from '../actions/types';
import { constants } from '../Constants/constants';

const INITIAL_STATE = {
    ui: {
        folder: _.cloneDeep(constants.FOLDER_INPUT)
    }
}

const folderReducer = (state = INITIAL_STATE, action) => {
    switch (action.type) {
        case FOLDER.SET_FOLDER_DEFAULT:
            return Object.assign({}, INITIAL_STATE)
        case FOLDER.SET_FOLDER:
        case FOLDER.SET_FOLDER_VALUE:
            return Object.assign({}, {
                ...state,
                ui: {
                    ...state.ui,
                    folder: action.folder
                }
            })
        default:
            return state
    }
}

export default folderReducer